import * as compliance from './complianceCard.json';
import * as kbCombo from './kbCombo.json';
import * as kbComboVoice from './kbCombo_Voice.json';
import * as sentiment from './Sentiment.json';
import * as salesOffers from './salesOffers.json';
import * as conversationAssistance from './conversationAssistance.json';
import * as intentAndAssistance from './intentAndAssistance.json';
import * as journeySummary from './journeySummary.json';
import * as salesOffersVoice from './salesOffersVoice.json';
import * as complianceVoice from './complianceCardVoice.json';
import * as agentTransfer from './agentTransfer.json';
import * as autopilotTransfer from './autopilotTransfer.json';
import * as intentSuccess from './intentSuccess.json';
import * as behavioralGuidance from './behavioralGuidanceCard.json';
import * as emailResponseSuggested from './emailResponseSuggested.json';
import * as emailResponseGenerated from './emailResponseGenerated.json';
import * as emailResponseSuggestedLive from './emailResponseSuggestedLive.json';
import * as emailResponseGeneratedLive from './emailResponseGeneratedLive.json';
import * as feedback from './feedback.json';
import * as kbComboEmail from './kbCombo_Email.json';
import { AgentCopilotContent } from '../enum/AgentCopilotContent';

const {
  COMPLIANCE_CARD,
  KB_COMBO,
  KB_COMBO_VOICE,
  SALES_OFFER,
  SENTIMENT,
  CONVERSATION_ASSISTANCE,
  INTENT_ASSISTANCE,
  JOURNEY_SUMMARY,
  SALES_OFFER_VOICE,
  COMPLIANCE_CARD_VOICE,
  AGENT_TRANSFER,
  AUTOPILOT_TRANSFER,
  INTENT_INPROGRESS,
  EMAIL_RESPONSE_GENERATED,
  EMAIL_RESPONSE_SUGGESTED,
  EMAIL_RESPONSE_SUGGESTED_LIVE,
  EMAIL_RESPONSE_GENERATED_LIVE,
  INTENT_COMPLETED,
  BEHAVIORAL_GUIDANCE,
  FEEDBACK,
  KB_COMBO_EMAIL,
} = AgentCopilotContent;

export const allAdaptiveCardSchemas = {
  [COMPLIANCE_CARD]: compliance,
  [KB_COMBO]: kbCombo,
  [KB_COMBO_VOICE]: kbComboVoice,
  [SALES_OFFER]: salesOffers,
  [SENTIMENT]: sentiment,
  [CONVERSATION_ASSISTANCE]: conversationAssistance,
  [INTENT_ASSISTANCE]: intentAndAssistance,
  //[INTENT_ASSISTANCE]: intents,
  [JOURNEY_SUMMARY]: journeySummary,
  [SALES_OFFER_VOICE]: salesOffersVoice,
  [COMPLIANCE_CARD_VOICE]: complianceVoice,
  [AGENT_TRANSFER]: agentTransfer,
  [AUTOPILOT_TRANSFER]: autopilotTransfer,
  [INTENT_COMPLETED]: intentSuccess,
  [BEHAVIORAL_GUIDANCE]: behavioralGuidance,
  [FEEDBACK]: feedback,
  [EMAIL_RESPONSE_SUGGESTED]: emailResponseSuggested,
  [EMAIL_RESPONSE_GENERATED]: emailResponseGenerated,
  [EMAIL_RESPONSE_SUGGESTED_LIVE]: emailResponseSuggestedLive,
  [EMAIL_RESPONSE_GENERATED_LIVE]: emailResponseGeneratedLive,
  [KB_COMBO_EMAIL]: kbComboEmail,
};
